<template>
  <div
    class="BaseCheckbox"
    :checked="value"
    :disabled="disabled"
    tabindex="0"
    @keyup.enter.space="handleCheck"
    @click="handleCheck">

    <div class="BaseCheckbox_Box">
      <svg
        class="BaseCheckbox_svg"
        viewBox="0 0 16 16"
        key="BC-checkmark">
        <path
          class="BaseCheckbox_checkmark"
          d="M3.75 8.5 6.5 12 12.25 3.75"
        />
      </svg>
    </div>

    <div
      class="BaseCheckbox_label"
      v-text="label">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',

  props: {
    value:    { type: Boolean, default: false },
    label:    { type: String,  default: 'Label' },
    disabled: { type: Boolean, default: false },
  },

  methods: {
    handleCheck() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

$box-size: 18px;

.BaseCheckbox {
  display: inline-block;
  position: relative;
  text-align: left;
  white-space: nowrap;
  border-radius: $radius;
  outline: none;
}

.BaseCheckbox:not([disabled]) {
  cursor: pointer;
}

.BaseCheckbox_Box {
  display: inline-block;
  position: relative;
  width: $box-size;
  height: $box-size;
  vertical-align: text-top;
  border-width: 1px;
  border-style: solid;
  border-color: $border-color;
  border-radius: $radius;
  background-color: $white;
  transition: all .2s ease 0s;
}

.BaseCheckbox:hover .BaseCheckbox_Box,
.BaseCheckbox:focus .BaseCheckbox_Box {
  border-color: $light-blue;
}

.BaseCheckbox_label {
  display: inline-block;
  margin-left: -$box-size;
  padding-left: $box-size + 8px;
  vertical-align: text-top;
  font-size: 14px;
  line-height: $box-size;
  white-space: normal;
}

.BaseCheckbox_svg {
  display: block;
  position: absolute;
  top: -1px;
  left: -1px;
  width: $box-size;
  height: $box-size;
}

.BaseCheckbox_checkmark {
  fill: none;
  stroke: $white;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: $box-size;
  stroke-dashoffset: $box-size;
  transition: all .3s ease 0s;
}

.BaseCheckbox[checked] .BaseCheckbox_Box {
  background: $light-blue;
  border-color: $light-blue;
}

.BaseCheckbox[checked] .BaseCheckbox_checkmark {
  stroke-dashoffset: 0;
}
</style>
